<template>
    <sp-form
        class="mobile-general-form-datetime-picker"
        :class="`uuid-${config.uuid} ${globalModel.preview ? 'preview-text' : ''} ${notChanged ? 'disable-opacity' : ''}`"
        ref="elForm"
        v-show="!props.hide"
        :model="formModel"
        :rules="rules"
    >
        <div v-if="!globalModel.preview" @click="onClickForm">
            <sp-form-item prop="value">
                <sharp-comp-select
                    :label="i18nLabel"
                    :is-required="props.required"
                    :selected-options-text="valueText"
                    :placeholder="i18n(props.placeholder)"
                    :disabled="notChanged"
                    @click="onClick"
                ></sharp-comp-select>
                <div v-if="props.dateTips" class="tips">
                    {{ props.dateTips}}
                </div>
            </sp-form-item>
            <sp-popup
                v-model="showPopup"
                disable-scroll
                transfer-dom
                popup-class="van-datetime-popup"
                position="bottom"
            >
                <van-datetime-picker
                    v-model="datetimeValue"
                    :type="props.type"
                    :title="i18n(props.title)"
                    :min-date="minDate"
                    :max-date="maxDate"
                    :confirm-button-text="i18n(props.confirmButtonText)"
                    :cancel-button-text="i18n(props.cancelButtonText)"
                    @confirm="onPickerConfirm"
                    @cancel="onPickerCancel"
                ></van-datetime-picker>
            </sp-popup>
        </div>
        <!-- 预览时的效果 -->
        <PreviewText
            v-else
            :labelText="i18nLabel"
            :textDesc="valueText"
        ></PreviewText>
        <sub-title class="mt16 error-right" v-if="lastShowRejectTip(i18nLabel)" :errorMsg="outputError(i18nLabel)"></sub-title>
    </sp-form>
</template>
<script>
import { Form, FormItem, Popup } from '@ks/sharp-ui';
import SharpCompSelect from '@ks/sharp-comp-form-select';
import '@ks/sharp-comp-form-select/lib/themes/default/index.css';
import { DatetimePicker } from 'vant';
import isEqual from 'lodash/isEqual';
import ComponentBase from '../component-base';
import { component } from './props';
import PreviewText from '../component-base/common/preview-text';
import formEventBus, { FORM_EVENTS_TYPE } from '../../utils/event-bus';
import { dateCalcMap } from './date-utils';
import SubTitle from '../component-base/common/sub-title';


export default {
    name: component,
    components: {
        SpForm: Form,
        SpFormItem: FormItem,
        SpPopup: Popup,
        SharpCompSelect,
        VanDatetimePicker: DatetimePicker,
        PreviewText,
        SubTitle,
    },
    extends: ComponentBase,
    data() {
        return {
            formModel: {
                value: null,
            },
            showPopup: false,
            datetimeValue: null,
        };
    },
    computed: {
        rules() {
            const otherRules = [];
            const ocrDateRangeValidator = this.props.ocrDateRangeValidator || '';
            if (ocrDateRangeValidator && ocrDateRangeValidator.op) {
                otherRules.push({
                    validator: this.dateRageValidator,
                });
            }
            return {
                value: this.composeRules(this.props, { otherRules }),
            };
        },
        // 格式化根据type也就4种情况，我自己写一个格式化好了
        // TODO 时间的格式化输出还要考虑国际化，这个坑太大了，暂时先不做
        valueText() {
            const value = this.formModel.value;
            if (this.isEmptyValue(value)) {
                return '';
            }
            const dateObj = new Date(value);
            switch (this.props.type) {
                case 'date':
                    return dateObj.toLocaleDateString();
                case 'time':
                    return dateObj.toLocaleTimeString();
                case 'year-month':
                    return `${dateObj.getFullYear()}/${dateObj.getMonth() + 1}`;
                default:
                    return dateObj.toLocaleString();
            }
        },
        minDate() {
            // 相对时间优先
            if (typeof this.props.minDateOffset === 'number') {
                return new Date(+new Date() + this.props.minDateOffset);
            }
            // 其次采用时间戳
            if (typeof this.props.minDateTimestamp === 'number') {
                return new Date(this.props.minDateTimestamp);
            }
            return undefined;
        },
        maxDate() {
            if (typeof this.props.maxDateOffset === 'number') {
                return new Date(+new Date() + this.props.maxDateOffset);
            }
            if (typeof this.props.maxDateTimestamp === 'number') {
                return new Date(this.props.maxDateTimestamp);
            }
            return undefined;
        },
        logParams() {
            return {
                is_connect_ocr: this.props.ocrConfig && this.props.ocrConfig.ocrKey ? 1 : 0,
                item_title: this.i18nLabel,
            };
        },
    },
    watch: {
        showPopup(val) {
            formEventBus.$emit(FORM_EVENTS_TYPE.IS_OPEN_PICKER, val);
        },
    },
    mounted() {
        !this.globalModel.preview && formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, 'SHOW', 'FILL_IN_DATE_ITEM', this.logParams);
    },
    methods: {
        isEmptyValue(value) {
            return value === null || typeof value === 'undefined';
        },
        // 根据type清空多余的时间
        resetDate(date) {
            switch (this.props.type) {
                case 'date':
                    // 选择日期时清空时间
                    date.setHours(0, 0, 0, 0);
                    break;
                case 'time':
                    // vant的时间格式居然是字符串我服了
                    return `${date.getHours()}:${date.getMinutes()}`;
                case 'year-month':
                    date.setDate(1);
                    break;
            }
            return date;
        },
        // vant组件抛出来的时间格式需要处理一下
        processPickerValue(val) {
            // 时间格式会抛出字符串格式
            if (typeof val === 'string') {
                const time = val.split(':');
                val = new Date();
                if (this.props.timeModeResetDate) {
                    val.setFullYear(1970, 0, 1, time[0], time[1], 0, 0);
                } else {
                    val.setHours(time[0], time[1], 0, 0);
                }
            }
            // 其他则是date对象，直接转时间戳
            return +val;
        },
        async onClick() {
            formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, 'CLICK', 'FILL_IN_DATE_ITEM', this.logParams);
            this.datetimeValue = this.resetDate(
                this.isEmptyValue(this.formModel.value)
                    ? new Date()
                    : new Date(this.formModel.value)
            );
            this.showPopup = true;
        },
        onPickerCancel() {
            this.showPopup = false;
        },
        onPickerConfirm(val) {
            this.showPopup = false;
            this.formModel.value = this.processPickerValue(val);
            this.onValueChange();
            this.$emit('user-input');
        },
        onValueChange() {
            const res = this.setSelfFormDataValue(this.formModel.value);
            if (res) {
                // 数据修改成功，抛出change事件，触发依赖
                this.$emit('change');
            }
        },
        /**
         * 以下是组件公共方法的实现
         */
        dataChangeHandler() {
            const newValue = this.getSelfFormDataValue();
            if (typeof newValue === 'undefined') {
                // 默认值逻辑
                if (this.formModel.value) {
                    this.formModel.value = null;
                }
                this.onValueChange();
                // this.validate();
                return;
            }

            if (!isEqual(this.formModel.value, newValue)) {
                this.formModel.value = newValue;
                // 数据被动修改同样抛出change事件
                this.$emit('change');
                // this.validate();
            }
        },
        getDataFromComponents(ocrDateRangeValidatorData) {
            return this.formModel.value;
        },
        dateRageValidator(rule, value, callback) {
            if (value === '长期有效') {
                callback();
                return;
            }
            let ocrDateRangeValidatorData;
            try {
                ocrDateRangeValidatorData = this.props.ocrDateRangeValidator;
            } catch (e) {
                // 
            }
            const { range, op, errorMsg, compare = 'end' } = ocrDateRangeValidatorData;
            if (!dateCalcMap[compare][op](value, range)) {
                callback(new Error(errorMsg));
            } else {
                callback();
            }
        },
        async validate() {
            if (this.skipValidate()) {
                return true;
            }
            const promise = new Promise((resolve, reject) => {
                this.$refs.elForm.validate((valid, invalidFields) => {
                    valid ? resolve(valid) : reject(invalidFields);
                });
            });
            try {
                return await promise;
            } catch (e) {
                this.validateFailureHandler(e.value[0].message);
                return false;
            }
        },
        clearValidate() {
            this.$refs.elForm.clearValidate();
        },
    },
};
</script>

<style lang="less">
.van-datetime-popup.sp-popup {
    z-index: 9999;

    .sp-popup__box {
        border-radius: 12px 12px 0 0;
    }
    .van-picker {
        .van-picker__cancel {
            font-size: 17px;
            color: #777;
        }
        .van-picker__title {
            font-size: 17px;
            color: #222;
            font-weight: 500;
        }
        .van-picker__confirm {
            font-size: 17px;
            color: #fe3666;
        }
    }
}
</style>
<style lang="less" scoped>
@import '../../style.less';
.tips {
    color: var(--font-notice, #9C9C9C);
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
}
</style>
